import type { Institution } from '@/services/firestore';

// Aplica filtro de categoria. Quando category é null ou 'all', retorna a lista original.
export function applyCategoryFilter<T extends Institution & { [key: string]: any }>(
  institutions: T[],
  category: Institution['category'] | null
): T[] {
  if (!category) return institutions;
  return institutions.filter((i) => (i.category || '').trim() === category);
}